import React, { FC, useState } from 'react';
import { ReactComponent as FailTripIcon } from 'assets/icons/truck-remove.svg';
import { BaseModal, Button, Input, Textarea } from '@cokitchen/cokitchen-components';

interface FailTripModalType {
  show: boolean;
  onClose: () => void;
}

interface FailTripModalFooterType {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}

const FailTripModalFooter: FC<FailTripModalFooterType> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

type FailTripReasonType =
  | 'Took too long to deliver'
  | 'Rider failed to deliver'
  | 'Rider nah thief*'
  | 'Partner has fired rider'
  | 'Other';

const FailTripModal: FC<FailTripModalType> = ({ show, onClose }) => {
  const [loading] = useState<boolean>(false);
  const [failTripReason, setFailTripReason] = useState<FailTripReasonType | ''>('');
  const [deductAmount, setDeductAmount] = useState(false);

  const failTripReasons: FailTripReasonType[] = [
    'Took too long to deliver',
    'Rider failed to deliver',
    'Rider nah thief*',
    'Partner has fired rider',
    'Other'
  ];
  const sendDetails = () => {
    console.log('delete partner');
  };

  const [amount, setAmount] = useState('');
  return (
    <BaseModal
      isOpen={show}
      title='Fail Trip'
      description='Any reason why you are marking this trip as failed?'
      titleIcon={<FailTripIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={<FailTripModalFooter loading={loading} onCancel={onClose} onConfirm={sendDetails} />}>
      <div className='space-y-6 h-auto max-h-[330px] px-1 overflow-scroll no-scroll-bar'>
        <div className='grid md:grid-cols-2 gap-2'>
          {failTripReasons?.map((item, index) => (
            <Input
              type='radio'
              key={index}
              checked={failTripReason === item}
              onChange={() => setFailTripReason(item)}
              label={item}
            />
          ))}
        </div>

        {failTripReason === 'Other' && (
          <div>
            <Textarea
              className='placeholder:text-[##A6A6A6] placeholder:font-normal'
              placeholder='Add a comment...'
            />
            <p className='text-xs text-gray-5'>Word limit: 0/150</p>
          </div>
        )}
        <div className='border-t border-t-[#EBEBEB] border-dashed py-3 space-y-5'>
          <Input
            type='checkbox'
            checked={deductAmount}
            onChange={() => setDeductAmount(!deductAmount)}
            label='Deduct Amount'
          />
          {deductAmount && (
            <Input
              currency
              name='amount'
              label='Enter Amount'
              placeholder='Amout'
              small
              onChange={(e) => setAmount(e.target.value)}
              value={amount}
            />
          )}
        </div>
      </div>
    </BaseModal>
  );
};

export default FailTripModal;
